import book from 'routes/book';

export const DEFAULT_REDIRECT_PATH = book.main;

export const DOMAINS_WHITE_LIST = ['https://birzha.5stars.kz', 'https://birzha.tat.ua'];
